
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { map as _map } from 'lodash';
import { DLDocument } from './document';

const ProcessedTemporaryDocumentQuery = require('./gql/document/processed-temporary-document.query.gql');
const createDLTemporaryDocumentMutation = require('./gql/document/create-temporary-document.mutation.gql');
const createDLDocumentMutation = require('./gql/document/create-document.mutation.gql');
const updateDLDocumentMutation = require('./gql/document/update-document.mutation.gql');
const deleteDLDocumentMutation = require('./gql/document/delete-document.mutation.gql');

export interface CreateDLDocumentInput {
  processedDocumentId: string
  date: string
  comment?: string
  rootCertificatePem?: string
}

interface UpdateDLDocumentInput {
  date: string
  comment?: string
}

interface CreateDLTemporaryDocumentInput {
  filename: string
  filetype: string
}

interface DLTemporaryDocumentUploadFormItem {
  key: string
  value: string
}

export interface DLTemporaryDocument {
  id: string
  companyId: string
  ledgerId: string
  filename: string
  filetype: string
  uploadURL: string
  uploadForm: DLTemporaryDocumentUploadFormItem[]
  createdAt: number
}

interface DLProcessedTemporaryDocument {
  id: string
  companyId: string
  ledgerId: string
  filename: string
  filetype: string
  filesize: number
  
  rootCertificateName?: string
  rootCertificatePem?: string

  verified: boolean
  authenticity: boolean
  integrity: boolean
  expired: boolean
  meta: any

  createdAt: number
}

@Injectable()
export class DLDocumentService {

  constructor(private apollo: Apollo) { }

  processedTemporaryDocument(id: string): Observable<DLProcessedTemporaryDocument> {
    return this.apollo
      .query({
        query: ProcessedTemporaryDocumentQuery,
        variables: {
          id
        },
        fetchPolicy: 'no-cache'
      }).pipe(
      map(result => result.data['dlProcessedTemporaryDocument'] as DLProcessedTemporaryDocument));
  }

  createTemporaryDocument(company: string, ledger: string, input: CreateDLTemporaryDocumentInput): Observable<DLTemporaryDocument> {
    return this.apollo
      .mutate({
        mutation: createDLTemporaryDocumentMutation,
        variables: {
          company,
          ledger,
          input,
        }
      }).pipe(
      map(result => result.data['createDLTemporaryDocument'] as DLTemporaryDocument));
  }

  createDocument(company: string, ledger: string, input: CreateDLDocumentInput): Observable<DLDocument> {
    return this.apollo
      .mutate({
        mutation: createDLDocumentMutation,
        variables: {
          company,
          ledger,
          input,
        }
      }).pipe(
      map(result => new DLDocument(result.data['createDLDocument'])));
  }

  updateDocument(company: string, ledger: string, id: string, input: UpdateDLDocumentInput): Observable<DLDocument> {
    return this.apollo
      .mutate({
        mutation: updateDLDocumentMutation,
        variables: {
          company,
          ledger,
          id,
          input,
        }
      }).pipe(
      map(result => new DLDocument(result.data['updateDLDocument'])));
  }

  delete(company: string, ledger: string, id: string): Observable<string> {
    return this.apollo
      .mutate({
        mutation: deleteDLDocumentMutation,
        variables: {
          company,
          ledger,
          id
        }
      }).pipe(
      map(result => result.data['deleteDLDocument']));
  }
}
